import AddProductComment from '../add-shared/AddProductComment';
import patch from '../add-shared/patch';
import AddCountryForm from './AddCountryForm';

export default {
  label: 'Add Country',
  value: 'Add Country',
  Comment: AddProductComment,
  Form: AddCountryForm,
  patch,
  initialState() {
    return { campaignLines: [] }; // This initializes the change object. It is provided as `value` to the form component
  },
};
